import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SearchResult} from '../../interfaces/interfaces';
import WKT from 'ol/format/WKT';
import { Point } from 'ol/geom';
import { reprojectCoordTo3857} from '../../util'; 
/* needed to parse well known text format */
const wktFormat = new WKT();


/**
 * Pareses a well known text point to ol coordinates.
 * @param point The well known text point to parse.
 * @returns The coordinates in
 */
const parseAdressWktPoint = (point: string) => {
    const geom = wktFormat.readGeometry(point, {
      dataProjection: 'EPSG:3857',
      featureProjection: 'EPSG:31287',
    });
    if (geom instanceof Point) {
      return reprojectCoordTo3857(geom.getCoordinates());
    } else {
      return [0, 0];
    }
  };


interface Doc {
    id:string,
    score: number;
    geo: string[];
    title: string[];
}

interface AdressSearchResponse  {
    response: {
        docs: Doc[]
    }
}

const parseAddressSearchDoc = (doc: Doc): SearchResult => {
    const coords = parseAdressWktPoint(doc.geo[0]);
    return {
        id: doc.id,
        layer: 'Adresse',
        label: doc.title[0],
        centroid: [coords[0], coords[1]],
        extent: [coords[0], coords[1], coords[0], coords[1]],
    };
}; 



export const parseAddressSearchResponse = (searchResponse: AdressSearchResponse) => searchResponse.response.docs.map(doc => parseAddressSearchDoc(doc));

 





// Define a service using a base URL and expected endpoints
export const adressApi = createApi({
    reducerPath: 'adressSearchApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://srv.doris.at/solr/searchservice/search/adressen2/' }),
    
    endpoints: (builder) => ({
        searchAdress: builder.query<AdressSearchResponse,string>({
            query: (query) => `?q=${query}`,
         }),
        
    }),

});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSearchAdressQuery } = adressApi;



 